/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate, useParams } from "react-router-dom";
import { Autocomplete, Badge, Skeleton, Stack } from "@mui/material";
import { MODULE_MASTER } from "utils/constant"
import CrudService from "services/cruds-service";
import ModalModuleAddress from "../add-module";
import { toast } from 'react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import { AuthContext } from "context";
import DataTable from "examples/Tables/DataTable";
import { useAbility } from "@casl/react";
import { AbilityContext } from "Can";

const EditEntity = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const ability = useAbility(AbilityContext)
    const authContext = useContext(AuthContext)
    if(authContext?.userDetail?.role_id === 6 && !ability.can('edit', 'entities')){
      navigate('/device-dashboard')
    }

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });

    const [error, setError] = useState({
        name: false,
        firstName: false,
        lastName: false,
        company: false,
        error: false,
        textError: "",
    });

    const [entity, setEntity] = useState("");
    const [company, setCompany] = useState("");
    const [companies, setCompanies] = useState([]);
    const [addressTypes, setAddressTypes] = useState([]);
    const [entityType, setEntityType] = useState([]);
    const [entityTypes, setEntityTypes] = useState([]);
    const [statusAddress, setStatusAddress] = useState([]);
    const [statusType, setStatusType] = useState([]);
    const [statusEntity, setStatusEntity] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [selectedId, setSelectedId] = useState(0);
    const [items, setItems] = useState([]);
    const [attributeValue, setAttributeValue] = useState([]);
    const [module, setModule] = useState([]);

    ///////////////// contact addresss ////////////////
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [loader, setLoader] = useState(true)

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });

    // const [descError, setDescError] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const response = await CrudService.getEntityTypes();
                setEntityTypes(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
        (async () => {
            try {
                const response = await CrudService.getCompanies();
                setCompanies(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
        (async () => {
            try {
                const response = await CrudService.getAddressTypes();
                setAddressTypes(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
        (async () => {
            try {
                const response = await CrudService.getStatusTypes(MODULE_MASTER.ADDRESS);
                setStatusAddress(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            try {
                const response = await CrudService.getStatusTypes(MODULE_MASTER.ENTITIES);
                setStatusEntity(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            const response = await CrudService.getItems();
            const formattedItems = response.data.map(element => {
                // Rename 'item_id' field to 'id' and include the existing 'id' field
                const { item_id, id, ...attributes } = element.attributes;
                return { id: item_id, ...attributes };
            });
            setItems(formattedItems);
        })();

    }, []);

    useEffect(() => {
        if (!id) return;
        (async () => {
            try {
                const res = await CrudService.getEntity(id);
                if(res?.data?.attributes?.created_by_user_id !== authContext.userDetail.id && [6, 7].includes(authContext.userDetail.role_id)){
                    navigate('/entity-list')
                }
                setEntity({
                    id: res.data.attributes.entity_id,
                    name: res.data.attributes?.name,
                    firstName: res.data.attributes?.first_name,
                    lastName: res.data.attributes?.last_name,
                    company: res.data.attributes?.Company,
                    entityType: res.data.attributes?.EntityType,
                    statusType: res.data.attributes?.StatusType,
                });
                setCompany({ attributes: res.data.attributes?.Company });
                setEntityType({ attributes: res.data.attributes?.EntityType });
                setStatusType({ attributes: { StatusType: res.data.attributes?.StatusOption?.StatusType } });
                setSelectedContacts(res.data.included?.contacts);
                setLoader(false)
                const moduleLocations = res.data.included?.moduleLocations;
                if (moduleLocations) {
                    const addresses = moduleLocations.map(location => location.Address);
                    const defaultIndex = moduleLocations.findIndex(location => location.is_default === true)
                    setAddresses(addresses);
                    setSelectedId(defaultIndex);
                } else {
                    // Handle the case where moduleLocations is null or undefined
                    setAddresses([]);
                }
                // setAddresses(res.data.included?.moduleLocations);
            } catch (err) {
                console.error(err);
            }
        })();
    }, [id]);

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
    }, [notification]);

    const changeNameHandler = (e) => {
        setCompany({ ...company, name: e.target.value });
        setEntity({ ...entity, name: e.target.value });

    };

    const changeFirstNameHandler = (e) => {
        setCompany({ ...company, firstName: e.target.value });
        setEntity({ ...entity, firstName: e.target.value });
    };

    const changeLastNameHandler = (e) => {
        setCompany({ ...company, lastName: e.target.value });
        setEntity({ ...entity, lastName: e.target.value });
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        let hasInvalidAddress = false;

        addresses.forEach(address => {
            if (address.status_type_id === '') {
                toast.warning('Please set Status of Address!', {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                hasInvalidAddress = true; // Set the flag to true if an invalid address is found
                return;
            }
            if (address.address_type_id === '') {
                toast.warning('Please set Type of Address!', {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                hasInvalidAddress = true
                return;
            }

        })

        if (hasInvalidAddress) {
            return;
        }

        const updatedEntity = {
            data: {
                type: "entities",
                attributes: {
                    name: entity.name,
                    first_name: entity.firstName,
                    last_name: entity.lastName,
                    company: company?.attributes,
                    entityType: entityType?.attributes,
                    statusType: statusType?.attributes,
                    addresses,
                },
                selectedId: selectedId
            },
        };

        try {
            authContext.startLoading()
            await CrudService.updateEntity(updatedEntity, id);
            navigate("/entity-list", {
                state: { value: true, text: "The entity was successfully Updated" },
            });
        } catch (err) {
            if (err.hasOwnProperty("error")) {
                setName({ ...name, error: true, textError: err.error });
            } else {
                toast.error(err.error);
            }
            console.error(err);
        } finally {
            authContext.stopLoading()
        }
    };

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {
            let phone = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 1 && contact.is_default === true);
            let email = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 2 && contact.is_default === true);
            let fax = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 3 && contact.is_default === true);
            return {
                // StatusType: row.attributes?.StatusOption,
                status_badge: (
                    <Badge
                        color={row.attributes?.StatusOption?.BadgeDetail?.color || 'primary'}
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: '30px' }}
                    >
                    </Badge>
                ),
                status: row.attributes?.StatusOption,
                type: "contacts",
                id: row.attributes?.contact_id,
                first_name: row.attributes?.first_name,
                last_name: row.attributes?.last_name,
                type: row.attributes?.ContactType?.type_name,
                phone: phone ? phone.contact_address : '', // Render phone.contact_address if phone exists, otherwise an empty string
                email: email ? email.contact_address : '', // Render email.contact_address if email exists, otherwise an empty string
                fax: fax ? fax.contact_address : '',
            };
        });
        return updatedInfo;
    };

    const dataTableAllData = {
        columns: [
            { Header: "Status", accessor: "status_badge", width: "15%" },
            { Header: "First Name", accessor: "first_name", width: "15%" },
            { Header: "Last Name", accessor: "last_name", width: "15%" },
            { Header: "Type", accessor: "type", width: "20%" },
            { Header: "Phone", accessor: "phone", width: "15%" },
            { Header: "Email", accessor: "email", width: "15%" },
            { Header: "Fax", accessor: "fax", width: "15%" },
        ],
        rows: getRows(selectedContacts),
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/* <ToastContainer/> */}
            {notification.value && (
                <MDAlert
                    color={notification.bgColor}
                    my="20px"
                    sx={{
                        position: "sticky",
                        top: { md: "100px", xs: "50px" },
                        zIndex: "10000",
                    }}
                >
                    <MDTypography variant="body2" color="white">
                        {notification.text || ""}
                    </MDTypography>
                </MDAlert>
            )}
            <MDBox mb={9}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Edit Entity {id}
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                This information will describe more about the entity.
                            </MDTypography>
                        </MDBox>
                        <Card>
                            <MDBox component="form" method="POST" onSubmit={submitHandler}>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <MDBox p={1}>
                                        {
                                            loader ? (
                                                <Stack gap={1}>
                                                    <Skeleton variant="rectangular" width="10%" />
                                                    <Skeleton variant="rectangular" />
                                                    <Skeleton variant="rectangular" width="10%" />
                                                    <Skeleton variant="rectangular" />
                                                    <Skeleton variant="rectangular" width="10%" />
                                                    <Skeleton variant="rectangular" />
                                                    <Skeleton variant="rectangular" width="10%" />
                                                    <Skeleton variant="rectangular" />
                                                </Stack>
                                            ) :
                                                <>
                                                    <Autocomplete
                                                        defaultValue=""
                                                        options={entityTypes}
                                                        getOptionLabel={(option) => (option.attributes ? option.attributes.type_name : "")}
                                                        value={entityType ?? ""}
                                                        onChange={(event, newEntityType) => {
                                                            setEntityType(newEntityType);
                                                        }}
                                                        renderInput={(params) => (
                                                            <FormField {...params} label="Entity Type" InputLabelProps={{ shrink: true }} required />
                                                        )}
                                                    />
                                                    {entityType.attributes?.entity_type_id === 1 && (
                                                        <>

                                                            <FormField
                                                                type="text"
                                                                label="First Name"
                                                                name="firstName"
                                                                value={entity.firstName}
                                                                onChange={changeFirstNameHandler}
                                                                error={error.firstName}
                                                            />
                                                            {error.firstName && (
                                                                <MDTypography variant="caption" color="error" fontWeight="light">
                                                                    {error.textError}
                                                                </MDTypography>
                                                            )}

                                                            <FormField
                                                                type="text"
                                                                label="Last Name"
                                                                name="lastName"
                                                                value={entity.lastName}
                                                                onChange={changeLastNameHandler}
                                                                error={error.lastName}
                                                            />
                                                            {error.lastName && (
                                                                <MDTypography variant="caption" color="error" fontWeight="light">
                                                                    {error.textError}
                                                                </MDTypography>
                                                            )}
                                                        </>
                                                    )}


                                                    {entityType.attributes?.entity_type_id === 2 && (
                                                        <>
                                                            <FormField
                                                                type="text"
                                                                label="Name"
                                                                name="name"
                                                                value={entity.name}
                                                                onChange={changeNameHandler}
                                                                error={error.name}
                                                            />
                                                            {error.name && (
                                                                <MDTypography variant="caption" color="error" fontWeight="light">
                                                                    {error.textError}
                                                                </MDTypography>
                                                            )}
                                                        </>
                                                    )}

                                                    <Autocomplete
                                                        defaultValue=""
                                                        options={companies}
                                                        getOptionLabel={(option) => (option.attributes ? option.attributes.name : "")}
                                                        value={company ?? ""}
                                                        onChange={(event, newCompany) => {
                                                            setCompany(newCompany);
                                                        }}
                                                        renderInput={(params) => (
                                                            <FormField {...params} label="Company" InputLabelProps={{ shrink: true }} required />
                                                        )}
                                                    />

                                                    <Autocomplete
                                                        defaultValue=""
                                                        options={statusEntity}
                                                        getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType.status_name : "")}
                                                        value={statusType ?? ""}
                                                        onChange={(event, newStatus) => {
                                                            setStatusType(newStatus);
                                                        }}
                                                        disableClearable
                                                        renderInput={(params) => (
                                                            <FormField {...params} label="Status" InputLabelProps={{ shrink: true }} required />
                                                        )}
                                                    />
                                                </>
                                        }
                                    </MDBox>
                                    {
                                        loader ?
                                            <Skeleton variant="rectangular" height={200} /> :
                                            <ModalModuleAddress addressTypes={addressTypes} statusOptions={statusAddress} addresses={addresses} setAddresses={setAddresses} selectedId={selectedId} setSelectedId={setSelectedId} moduleData={items} moduleType="Item" attributeValue={attributeValue} setAttributeValue={setAttributeValue} module={module} setModule={setModule} />
                                    }
                                    {
                                        loader ?
                                            <Skeleton variant="rectangular" height={200} sx={{ margin: '10px 0' }} /> :
                                            <Card sx={{ marginTop: '1rem', padding: '1rem 0' }}>
                                                <MDTypography ml={3}>
                                                    Selected Contact(s)
                                                    <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: '10px' }} onClick={() => navigate(`/entity-management/edit-entity/contact/${id}`)}>
                                                        Update
                                                    </MDButton>
                                                </MDTypography>
                                                <DataTable table={dataTableAllData} />
                                                {/* {
                                                    <ModalSelectContact
                                                        open={openSelect} entityId={id} setOpen={setOpenSelect} contacts={contacts} selectedContacts={selectedContacts} setSelectedContacts={setSelectedContacts} entityAddressItemList={entityAddressItemList}
                                                    />
                                                } */}

                                            </Card>
                                    }
                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/entity-list", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditEntity;
